import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TrendIcon from "../Trend/Icon.js";
import { formatValue } from "../utils/data.js";
import { getRatio, getDirection, getTrendClassName, getPercentageSymbol } from "../utils/trends.js";
const TrendWrapper = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.25rem"
}));
const TrendValue = styled(Typography)(({
  theme
}) => ({
  borderRadius: theme.sizes.radius.full,
  overflow: "hidden",
  display: "inline-flex",
  alignItems: "center",
  gap: theme.sizes.spacing["02"]
}));
const CellWithTrend = (t0) => {
  const $ = c(20);
  const {
    value,
    comparison,
    desiredTrend
  } = t0;
  if (typeof comparison !== "number") {
    let t12;
    if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      t12 = /* @__PURE__ */ jsxs(TrendWrapper, { className: "trend-neutral", children: [
        " ",
        "-",
        /* @__PURE__ */ jsx(TrendIcon, { direction: 0, size: "xs" })
      ] });
      $[0] = t12;
    } else {
      t12 = $[0];
    }
    return t12;
  }
  const comp = comparison;
  let direction;
  let directionClass;
  let formattedValue;
  let t1;
  if ($[1] !== comp || $[2] !== desiredTrend || $[3] !== value) {
    const ratio = getRatio(value, comp);
    let trend = 0;
    if (ratio > 1) {
      trend = ratio - 1;
    } else {
      if (ratio < 1) {
        trend = 1 - ratio;
      }
    }
    direction = getDirection(ratio);
    if (ratio === 0 && value === 0) {
      direction = 2;
    }
    directionClass = getTrendClassName(direction, desiredTrend);
    formattedValue = !direction ? "-" : formatValue(trend, {
      precision: 1,
      short: false,
      type: "percentage"
    });
    t1 = getPercentageSymbol(direction);
    $[1] = comp;
    $[2] = desiredTrend;
    $[3] = value;
    $[4] = direction;
    $[5] = directionClass;
    $[6] = formattedValue;
    $[7] = t1;
  } else {
    direction = $[4];
    directionClass = $[5];
    formattedValue = $[6];
    t1 = $[7];
  }
  const percentageSymbol = t1;
  const hasValidValue = value !== null && value !== void 0 && !isNaN(value);
  let t2;
  if ($[8] !== directionClass || $[9] !== formattedValue || $[10] !== percentageSymbol) {
    t2 = /* @__PURE__ */ jsxs(TrendValue, { variant: "number-sm", className: directionClass, children: [
      percentageSymbol,
      formattedValue
    ] });
    $[8] = directionClass;
    $[9] = formattedValue;
    $[10] = percentageSymbol;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== desiredTrend || $[13] !== direction || $[14] !== hasValidValue) {
    t3 = hasValidValue && /* @__PURE__ */ jsx(TrendIcon, { direction, size: "sm", desiredTrend });
    $[12] = desiredTrend;
    $[13] = direction;
    $[14] = hasValidValue;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== directionClass || $[17] !== t2 || $[18] !== t3) {
    t4 = /* @__PURE__ */ jsxs(TrendWrapper, { className: directionClass, children: [
      t2,
      t3
    ] });
    $[16] = directionClass;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
export {
  CellWithTrend as default
};
